"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function formatDegrees(degrees, positivePrefix, negativePrefix) {
  var prefix = degrees >= 0 ? positivePrefix : negativePrefix;
  var absDegrees = Math.abs(degrees);
  var flooredDegrees = Math.floor(absDegrees);
  var minutes = (absDegrees - flooredDegrees) * 60;
  return "".concat(prefix).concat(flooredDegrees, "\xB0 ").concat(minutes.toFixed(3), "\u2032");
}
var Position = function Position(props) {
  var latitude = props.latitude,
    longitude = props.longitude,
    address = props.address;
  var formattedAddress;
  if (!address) {
    formattedAddress = "".concat(formatDegrees(latitude, 'N', 'S'), " ").concat(formatDegrees(longitude, 'E', 'W'));
  } else {
    formattedAddress = address;
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'vehiclePositionInfo'
  }, formattedAddress);
};
Position.propTypes = {
  latitude: _propTypes["default"].number.isRequired,
  longitude: _propTypes["default"].number.isRequired,
  address: _propTypes["default"].string
};
var _default = Position;
exports["default"] = _default;